import gql from 'graphql-tag';

export const application = gql`
  fragment application on Application {
    id
    adcentreCandidateId
    adcentreProspectId
    candidateId
    applicationId
    firstName
    lastName
    email
    phone
    mostRecentJobTitle
    mostRecentCompanyName
    mostRecentRoleMonths
    appliedDateUtc
    statusFolder
    isRead
    isPriorityApply
    metadata {
      ... on ApplicationMetadataResponseSuccess {
        result {
          emailCount
          noteCount
          hasResume
          hasCoverLetter
          hasSelectionCriteria
        }
      }
      ... on ResponseError {
        error
      }
    }
    candidateStats {
      ... on ApplicationCandidateStatsResponseSuccess {
        result {
          totalApplicationCount
        }
      }
      ... on ResponseError {
        error
      }
    }
    rating {
      rating
    }
    source
    billableStatus
    matchedQualities {
      id
      isTop
      displayLabel
      relevanceScore
    }
    attachmentsV2 {
      ... on ApplicationAttachmentsV2ResponseSuccess {
        result {
          attachmentId
          attachmentType
          hasConvertedPdf
          fileName
        }
      }
      ... on ResponseError {
        error
      }
    }
    verifications {
      ... on ApplicationVerificationsResponseSuccess {
        result {
          title
          viewFields {
            label
            value
          }
        }
      }
      ... on ResponseError {
        error
      }
    }
    questionnaireSubmission {
      ... on ApplicationQuestionnaireSubmissionResponseSuccess {
        result {
          id
          questions {
            id
            legacyId
            text
            answers {
              id
              legacyId
              text
              verification {
                title
                viewFields {
                  label
                  value
                }
              }
            }
            status
            answerType
            source
          }
        }
      }
      ... on ResponseError {
        error
      }
    }
    profile {
      ... on ResponseError {
        error
      }
      ... on ApplicationProfileResponseSuccess {
        result {
          education {
            id
            name
            completed
            completionDate {
              year
              month
            }
            highlights
            institute
            credential {
              name
              values
            }
            verification {
              title
              viewFields {
                label
                value
              }
            }
          }
          licences {
            id
            name
            issuingOrganisation
            issueDate {
              month
              year
            }
            expiryDate {
              month
              year
            }
            noExpiryDate
            description
            formattedExpiryDate
            credential {
              name
              values
            }
            verification {
              title
              viewFields {
                label
                value
              }
            }
          }
          skills {
            keyword
          }
          workHistory {
            id
            title
            company
            startDate {
              month
              year
            }
            endDate {
              month
              year
            }
            achievements
          }
          rightsToWork {
            country
            answer
          }
          rightsToWorkV2 {
            id
            displayLabel(input: $displayLabelInput2)
          }
          verificationsStats {
            ... on ApplicationProfileVerificationsStatsSuccess {
              totalCount
            }
            ... on ResponseError {
              error
            }
          }
          verifications {
            ... on ApplicationProfileVerificationsSuccess {
              result {
                verifiedIdentity {
                  viewFields {
                    label
                    value
                  }
                }
                workHistory {
                  title
                }
                education {
                  title
                }
                licences {
                  title
                }
                rightToWork {
                  title
                }
              }
            }
            ... on ResponseError {
              error
            }
          }
          homeLocation {
            id
            displayDescription(input: $displayDescriptionInput2)
          }
          nationalities(input: $nationalitiesInput2) {
            ... on ResponseError {
              error
            }
            ... on ApplicationProfileNationalitiesResponseSuccess {
              result {
                id
                countryName(input: $countryNameInput2)
              }
            }
          }
          referenceChecksStats {
            ... on ApplicationProfileReferenceChecksStatsResponseSuccess {
              result {
                ... on ApplicationProfileReferenceChecksStatsRequested {
                  __typename
                  referenceCheckType
                }
                ... on ApplicationProfileReferenceChecksStatsAvailable {
                  referenceCheckType
                  finishedCount
                  totalCount
                }
              }
            }
          }
        }
      }
    }
    fit {
      ... on ApplicationFitResponseSuccess {
        result {
          summary
        }
      }
      ... on ResponseError {
        __typename
      }
    }
  }
`;
